"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clear = exports.copyOrderFailure = exports.copyOrderSuccess = exports.copyOrder = exports.deleteOrderFailure = exports.deleteOrderSuccess = exports.deleteOrder = exports.selectOrder = exports.setFilterOptions = exports.setOrderByOptions = exports.setOffset = exports.setLimit = exports.setSearchString = exports.fetchOrderListFailed = exports.fetchOrderListSuccess = exports.fetchOrderListRequest = void 0;
const ActionTypes = require("../../actionTypes/order/list");
const fetchOrderListRequest = (folder, filter = 'all', type = 'order') => ({
    type: ActionTypes.FETCH_REQUEST,
    payload: {
        folder,
        filter,
        type
    }
});
exports.fetchOrderListRequest = fetchOrderListRequest;
const fetchOrderListSuccess = (list, filter) => ({
    type: ActionTypes.FETCH_SUCCESS,
    payload: {
        list,
        filter
    }
});
exports.fetchOrderListSuccess = fetchOrderListSuccess;
const fetchOrderListFailed = (error) => ({
    type: ActionTypes.FETCH_FAILED,
    payload: {
        error
    }
});
exports.fetchOrderListFailed = fetchOrderListFailed;
const setSearchString = (searchString) => ({
    type: ActionTypes.SET_SEARCH_STRING,
    payload: {
        searchString
    }
});
exports.setSearchString = setSearchString;
const setLimit = (limit) => ({
    type: ActionTypes.SET_LIMIT,
    payload: {
        limit
    }
});
exports.setLimit = setLimit;
const setOffset = (offset) => ({
    type: ActionTypes.SET_OFFSET,
    payload: {
        offset
    }
});
exports.setOffset = setOffset;
const setOrderByOptions = (orderBy, order) => ({
    type: ActionTypes.SET_ORDER_BY_OPTIONS,
    payload: {
        orderBy,
        order
    }
});
exports.setOrderByOptions = setOrderByOptions;
const setFilterOptions = (filter, value) => ({
    type: ActionTypes.SET_FILTER_OPTIONS,
    payload: {
        filter,
        value
    }
});
exports.setFilterOptions = setFilterOptions;
const selectOrder = (order) => ({
    type: ActionTypes.SELECT_ORDER,
    payload: {
        order
    }
});
exports.selectOrder = selectOrder;
const deleteOrder = (id, project) => ({
    type: ActionTypes.DELETE_ORDER,
    payload: {
        id,
        project
    }
});
exports.deleteOrder = deleteOrder;
const deleteOrderSuccess = (orders) => ({
    type: ActionTypes.DELETE_ORDER_SUCCESS,
    payload: orders
});
exports.deleteOrderSuccess = deleteOrderSuccess;
const deleteOrderFailure = (error) => ({
    type: ActionTypes.DELETE_ORDER_FAILURE,
    payload: error
});
exports.deleteOrderFailure = deleteOrderFailure;
const copyOrder = (order) => ({
    type: ActionTypes.COPY_ORDER,
    payload: {
        order
    }
});
exports.copyOrder = copyOrder;
const copyOrderSuccess = () => ({
    type: ActionTypes.COPY_ORDER_SUCCESS
});
exports.copyOrderSuccess = copyOrderSuccess;
const copyOrderFailure = (error) => ({
    type: ActionTypes.COPY_ORDER_FAILURE,
    payload: error
});
exports.copyOrderFailure = copyOrderFailure;
const clear = () => ({
    type: ActionTypes.CLEAR
});
exports.clear = clear;
//# sourceMappingURL=list.js.map